module.exports = __webpack_public_path__ + "assets/img/banner.24b656c1.png";